import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch Location list
 * @param {Object} filters
 *  @param {Number} page Page number
 *  @param {Number} size list size
 *  @param {String} name search text
 *  @param {String} sort sorting format: field;ASC|DESC
 */
const fetchParameterList = async function ({ page, size, search, sort }) {
  try {
    let filters = {
      page, size, search, sort
    }
    console.log('TCL: filters', filters)
    const res = await axios.get(urls.parameterListGroup + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a parameter detail
 * @param {Number} parameterGroupId parameter group Id
 */
const fetchParameterDetail = async function ({ page, size, search, sort, parameterGroupId }) {
  try {
    let filters = {
      page, size, search, sort, parameterGroupId
    }
    console.log('TCL: filters', filters)
    const res = await axios.get(urls.parameterListMaster + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a sub parameter detail
 * @param {Number} id parameter Id
 */
const fetchSubParameterDetail = async function (id) {
  try {
    let res = await axios.get(urls.parameterById + '/' + id)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create or edit a parameter
 * @param {Object} form data form input
 * @param {Number} form.id basp Id for edit
 * @param {Boolean} form.parameterValue basp isActive
 * @param {Boolean} form.active basp isActive
 * @param {Number} form.expiredOn basp createdAt for edit
 */
const updateParameter = async function ({ id, parameterValue, active, expiredOn }) {
  try {
    let res
    let value = parameterValue
    const data = {
      id,
      value,
      active,
      expiredOn
    }
    console.log('TCL: data', data)
    res = await axios.put((urls.parameterById + '/' + id), data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchParameterList,
  fetchParameterDetail,
  fetchSubParameterDetail,
  updateParameter
}
